import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { CompaniesComponent } from './members/companies/companies.component';
import { CompanyDetailsComponent } from './members/companies/company-details/company-details.component';
import { ContractDetailsComponent } from './members/contracts/contract-details/contract-details.component';
import { ContractsComponent } from './members/contracts/contracts.component';
import { CreateContractComponent } from './members/create-contract/create-contract.component';
import { DashboardComponent } from './members/dashboard/dashboard.component';
import { PaymentsComponent } from './members/payments/payments.component';
import { QuotationComponent } from './members/quotation/quotation.component';
import { UsersComponent } from './members/users/users.component';
import { AuthGuard } from './_services/auth.guard';

import { LoansDasboardComponent } from './members/loans/loans-dasboard/loans-dasboard.component';
import { LoansQuotationComponent } from './members/loans/loans-quotation/loans-quotation.component';
import { LoansContractComponent } from './members/loans/loans-contract/loans-contract.component';
import { LoansPaymentsComponent } from './members/loans/loans-payments/loans-payments.component';
import { LoansCreateContractComponent } from './members/loans/loans-create-contract/loans-create-contract.component';
import { LoansContractDetailsComponent } from './members/loans/loans-contract-details/loans-contract-details.component';

import { PaymentBookComponent } from './members/loans/payment-book/payment-book.component';
import { PayBookComponent } from './members/pay-book/pay-book.component';

import { LoanRequestFormComponent } from './loan-request-form/loan-request-form.component';
import { LoginGuard } from './_services/login.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: "login", component: LoginComponent, canActivate: [LoginGuard] },
  { path: "loan-request-form", component: LoanRequestFormComponent },
  { path: "quotation", component: QuotationComponent, canActivate: [AuthGuard] },
  { path: "agencias", component: CompaniesComponent, canActivate: [AuthGuard]  },
  { path: "company-details/:id", component: CompanyDetailsComponent, canActivate: [AuthGuard]  },
  { path: "users", component: UsersComponent, canActivate: [AuthGuard]  },
  { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard]  },
  { path: "contracts", component: ContractsComponent, canActivate: [AuthGuard]  },
  { path: "payments", component: PaymentsComponent, canActivate: [AuthGuard]  },
  { path: "create-contract", component: CreateContractComponent, canActivate: [AuthGuard]  },
  { path: "contract-details", component: ContractDetailsComponent, canActivate: [AuthGuard]  },
  { path: "contract-details/:id", component: ContractDetailsComponent, canActivate: [AuthGuard]  },
  // { path: "loans/quotation", component: LoansQuotationComponent, canActivate: [AuthGuard]  },
  // { path: 'loans', redirectTo: 'loans/dashboard', pathMatch: 'full' },
  // { path: "loans/dashboard", component: LoansDasboardComponent, canActivate: [AuthGuard]  },
  // { path: "loans/contracts", component: LoansContractComponent, canActivate: [AuthGuard]  },
  // { path: "loans/payments", component: LoansPaymentsComponent, canActivate: [AuthGuard]  },
  // { path: "loans/create-contract", component: LoansCreateContractComponent, canActivate: [AuthGuard]  },
  // { path: "loans/contract-details/:id", component: LoansContractDetailsComponent, canActivate: [AuthGuard]  },
  // {
  //   path: "loans/pay-book/:id", component: PaymentBookComponent, canActivate: [AuthGuard] 
  // },
  {
    path: "pay-book/:id", component: PayBookComponent, canActivate: [AuthGuard] 
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, LoginGuard]
})
export class AppRoutingModule { }
